module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/caP0Q5/tc-custom/9781488069963.jpg?1708427513080",
      "alt": "This image is the cover for the book Her Man Behind the Badge, Men of the West"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Her Man Behind the Badge, Men of the West\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("From a "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author, a commitment-shy cop falls for a single mother and her young son in this western romance.")]), _c('br'), _c('br'), _vm._v("Connor’s Rules of Dating:"), _c('br'), _c('br'), _vm._v("No single moms."), _c('br'), _c('br'), _vm._v("No strings."), _c('br'), _c('br'), _vm._v("No complications."), _c('br'), _c('br'), _vm._v("Deputy Sheriff Connor Murphy had been disappointed enough in his youth to know that he doesn’t have what it takes to be a father. But when he meets lovely single mom Jazelle Hutton, he soon realizes that she and her little boy are a package deal! And the only way to get in her good graces is to open his heart not just to the woman who is rewriting all his rules, but the child who makes him throw away his rule book . . . "), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Stella Bagwell\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("The author of over seventy-five titles for Harlequin, Stella Bagwell writes about familes, the West, strong, silent men of honor and the women who love them. She credits her loyal readers and hopes her stories have brightened their lives in some small way. A cowgirl through and through, she recently learned how to rope a steer. Her days begin and end helping her husband on their south Texas ranch. In between she works on her next tale of love. Contact her at stellabagwell@gmail.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0